import { client } from 'pioneira-ui';

export default {
  namespaced: true,
  actions: {
    propostaSaldoRequisition(context, payload) {
      return client
        .post("/api/consulta-saldo", {
          cpf: payload,
        });
    },

    getfinishedConsultasSaldo() {
      return client
        .get("/api/consulta-saldo");
    },

    getStatusConsultaSaldo(context, payload) {
      return client
        .get(`/api/consulta-saldo-status/${payload}`);
    },

    getfinishedConsultaSaldo(context, payload) {
      return client
        .get(`/api/consulta-saldo/${payload}`);
    },

    getSaldoTitulosPendentes(context, payload) {
      return client
        .get("/api/consultar-titulos-pendentes");
    },

    deleteConsultaSaldo(context, payload) {
      return client
        .delete(`/api/cancelar-consulta/${payload}`);
    },
  },
};
